import { render, staticRenderFns } from "./supply-tab.vue?vue&type=template&id=ee76e38e&scoped=true"
import script from "./supply-tab.vue?vue&type=script&lang=js"
export * from "./supply-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee76e38e",
  null
  
)

export default component.exports